import React from "react";
import AboutUs from "../../components/CentroProfile/AboutUs";
import Cursos from "../../components/CentroProfile/Cursos";
import Empleos from "../CompanyProfile/Empleos";
import Formaciones from "../CompanyProfile/Formaciones";
import FotosVideos from "../CompanyProfile/FotosVideos";
import Valoraciones from "../CompanyProfile/Valoraciones";
import EventsList from "../Events/EventsList";

export const WrapperPerfil = ({ id, company, reload }) => {
  
  switch (id) {
    case 1:
      return <AboutUs company={company} reload={reload}></AboutUs>;
    case 2:
      return <Empleos id={company.companyProfileId}></Empleos>;
    case 3:
      return <Formaciones id={company.companyProfileId}></Formaciones>;
    case 5:
      return (
        <FotosVideos
          id={company.companyProfileId}
          reload={reload}
          edit={true}
        ></FotosVideos>
      );
    case 6:
      return (
        <Valoraciones
          company={company}
          reload={reload}
          edit={true}
        ></Valoraciones>
      );
      case 7:
      return (
        <EventsList
        data={company}
          reload={reload}
          edit={true}
        ></EventsList>
      );
    default:
      return <Cursos id={company.companyProfileId}></Cursos>;
  }
};

export default WrapperPerfil;
